import GridViewIcon from '@mui/icons-material/GridView';
import MenuIcon from '@mui/icons-material/Menu';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import TableRowsRoundedIcon from '@mui/icons-material/TableRowsRounded';
import './Sort.css'
import { useDispatch, useSelector } from 'react-redux';
import { setGridView, setListView, setSortMethod, sortProducts } from '../../Redux/Actions/product';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
const Sort = () => {
  const dispatch = useDispatch()
  const isGridView = useSelector(state => state.isGrid)
  const sortingMethod = useSelector((state) => state.sortingMethod.sorting_method)


  const gridViewHandler = () => {
    dispatch(setGridView())
  }
  const listViewHandler = () => {
    dispatch(setListView())
  }
  const sortHandler = (e) => {
    dispatch(setSortMethod());
  }

  useEffect(() => {
    dispatch(sortProducts(sortingMethod));
  }, [sortingMethod])

  return (
    <div className='sort-section'>
      <div className="sort-left">
        {isGridView ?<GridViewRoundedIcon onClick={gridViewHandler} fontSize='medium' className='gird-icon'/>:
          <GridViewIcon onClick={gridViewHandler} fontSize='medium' className='gird-icon'/>
        }
        {isGridView ?<MenuIcon onClick={listViewHandler} fontSize='medium' className='gird-icon'/>:
          <TableRowsRoundedIcon onClick={listViewHandler} fontSize='medium' className='gird-icon'/>
        }
      </div>
      <div className="sort-right">
        <form action="#">
          <label htmlFor="sort"></label>
          <select name="sort" id="sort" onChange={sortHandler} className="select-sort">
          <option   value="">Sort By</option>
            <option value="lowest">Price(lowest)</option>
            <option value="highest">Price(highest)</option>
            <option value="a-z">Name(a-z)</option>
            <option value="z-a">Name(z-a)</option>
            <option value="rating">Rating</option>
          </select>
        </form>
      </div>
    </div>
  )
}

export default Sort